import { assignedTrackCompleteness } from "../../../lib/weeklyTrackCompleteness.js";
import { isActiveHubProject } from "../hub/hubAccess.js";

// Collection population is supplied before search/facets. Selected-week track
// evidence is self-contained, especially when captured membership is missing.
export function updatesCollectionMetrics(projects) {
  const active = projects.filter(isActiveHubProject);
  return {
    active: active.length,
    atRisk: active.filter(p => p.statusOverall === "at_risk" || p.statusOverall === "critical" || p.flagged === true || p.isFlagged === true).length,
    onTrack: active.filter(p => p.statusOverall === "on_track").length,
    exits: active.filter(p => p.projectType === "exit").length,
  };
}

export function updatesTrackMetrics(overview) {
  if (!overview || overview.legacyUnavailable || !Array.isArray(overview.projects)) return null;
  const participation = overview.projects.map(assignedTrackCompleteness);
  if (participation.some(p => !p.available)) return null;
  return participation.reduce((sum, p) => ({ inCount: sum.inCount + p.inCount, total: sum.total + p.total }), { inCount: 0, total: 0 });
}

export function countCollectionDecisions(decisions, projects) {
  const ids = new Set(projects.filter(isActiveHubProject).map(p => p.id));
  return decisions.filter(d => ids.has(d.projectId) && d.status === "open").length;
}
